import { IFormField } from '../../../shared/interfaces/forms/IForms';
import { IUser } from '../../../shared/interfaces/user/IUser';
import { formDataHeaders, requests } from '../../../utils/api/api.service';
import { SELF_USER_FORM, USER_URL } from '../../../utils/api/endpoints';

export const UserEmployeeService = {
  update: (payload: FormData, id: number): Promise<IUser> =>
    requests.put(`${USER_URL}/self/${id}`, payload, formDataHeaders),
  getSelfUserForm: (
    userId: number,
  ): Promise<{
    1: IFormField[];
    2: IFormField[];
    3: IFormField[];
    4: IFormField[];
    5: IFormField[];
  }> => requests.get(`${SELF_USER_FORM}/${userId}`),
};
